/* eslint-disable object-curly-newline */

export default {
	status: 200,
	data: {
		code: 200,
		media: {
			author: 'National Geographic',
			created_at: '2019-06-20 12:25:32',
			id: 6550,
			name: 'City of the Future: Singapore – Full Episode | National Geographic',
			thumbnail: 'https://i.ytimg.com/vi/xi6r3hZe5Tg/hqdefault.jpg',
			type: 'video',
			url: 'https://www.youtube.com/watch?v=xi6r3hZe5Tg',
			website: 'https://www.youtube.com/user/NationalGeographic',
		},
	},
};
